import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const SITE = "https://www.kodpilot.com";
const SHARE = "https://kodpilot.com";
const OG_IMAGE = "https://kodpilot.com/og-image.png?v=4";
const LOCALES = { tr: "tr_TR", en: "en_US", de: "de_DE", ru: "ru_RU", zh: "zh_CN" };
const KNOWN = new Set(["/", "/gizlilik-politikasi", "/iptal-iade-sartlari"]);

// Alt sayfalar için başlık anahtarı (lang dosyalarındaki mevcut çeviriler)
const PAGE_TITLE_KEYS = {
  "/gizlilik-politikasi": "privacyPolicyTitle",
  "/iptal-iade-sartlari": "cancellationTermsTitle",
};

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo() {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const code = (i18n.resolvedLanguage || i18n.language || "tr").slice(0, 2);
    document.documentElement.lang = code;

    const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
    const known = KNOWN.has(path);
    const canonical = path === "/" ? `${SITE}/` : `${SITE}${path}`;
    const shareUrl = path === "/" ? `${SHARE}/` : `${SHARE}${path}`;
    const pageKey = PAGE_TITLE_KEYS[path];

    const siteTitle = t("seo.title");
    const description = known ? t("seo.description") : t("notFound.body");
    const title = !known
      ? `404 | KODPİLOT`
      : pageKey
        ? `${t(pageKey)} | KODPİLOT`
        : siteTitle;

    document.title = title;
    if (known) setCanonical(canonical);
    setMeta("name", "description", description);
    setMeta("name", "robots", known ? "index,follow,max-image-preview:large" : "noindex, nofollow");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "KODPİLOT");
    setMeta("property", "og:url", known ? shareUrl : `${SHARE}/`);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:locale", LOCALES[code] || "tr_TR");
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("property", "og:image:secure_url", OG_IMAGE);
    setMeta("property", "og:image:type", "image/png");
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:image:alt", "KODPİLOT — Henüz mümkün olmayanı kodlarız");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", OG_IMAGE);
  }, [t, pathname, i18n.language, i18n.resolvedLanguage]);

  return null;
}
